import { ORDER_METHODS } from '../../../../services/exports/Constants';

export default {
  text: {
    thank_you: 'Bedankt, {{name}}',
    confirmation_email:
      'Je ontvangt binnenkort een bevestigingsmail met je bestelnummer van onze technologiepartner {{provider_email}}',
    need_help: 'Hulp nodig?',
  },
  labels: {
    order_number: 'Bestelnr.: {{number}}',
    order_number_short: '#{{number}}',
    today: 'Vandaag',
    was_prefix: 'was',
    restaurant: 'Restaurant',
    order_details: 'Bestelgegevens',
    your_details: 'Jouw gegevens',
    contact: 'Contact',
    payment: 'Betaling',
    payment_method: 'Betaalmethode',
    delivery: 'Bezorging',
    delivery_details: 'Bezorggegevens',
    pickup_details: 'Afhaalgegevens',
    pickup_instruction: '📋 Geef bestelnummer {{number}} op bij het afhalen van je bestelling.',
    billing_info: 'Factuurgegevens',
    order_note: 'Bestelnotitie',
    order_summary: 'Besteloverzicht',
    help: 'Hulp nodig? Neem contact op via {{phone_number}}',
  },
  status: {
    canceled: 'Bestelling geannuleerd',
    received: 'Bestelling ontvangen',
    confirmed: 'Bestelling bevestigd!',
  },
  eta: {
    min_label: 'MIN',
  },
  order_methods: {
    [ORDER_METHODS.PICKUP]: 'Afhalen',
    [ORDER_METHODS.DELIVERY]: 'Bezorging',
    [ORDER_METHODS.ON_SITE]: 'Bestellen aan tafel',
  },
  rewards: {
    member: {
      pill_title: 'Verdiende punten',
      from_order: 'punten van deze bestelling',
      total_balance: 'Totaal saldo',
      reward_value: 'Beloningswaarde',
      redeem_hint: '✓ Je kunt tot {{points}} pts ({{amount}}) inwisselen op je volgende bestelling',
      points_to_redeem: 'Je hebt nog maar {{points}} punten nodig om je beloning in te wisselen',
    },
    guest: {
      pill_title: 'Beloningen',
      earned_heading: 'Je hebt <highlight>{{points}} punten</highlight> verdiend op deze bestelling',
      worth_on_next: 'Waard <strong>{{amount}}</strong> op je volgende bestelling',
      ready_to_claim: 'Klaar om te claimen',
      next_order_discount: 'Korting volgende bestelling',
      claim_cta: 'Claim je {{points}} pts — gratis aanmelden',
      claim_note: 'Duurt 30 seconden · je punten worden direct bijgeschreven',
    },
  },
  buttons: {
    back_to_menu: 'Terug naar menu',
    back_to_checkout: 'Terug naar afrekenen',
    contact_us: 'Neem contact op via {{phone_number}}',
    try_again: 'Opnieuw proberen',
  },
  loading: {
    processing_payment: 'Verlaat de pagina niet terwijl we je betaling verwerken',
  },
  success_messages: {
    order_placed: {
      title: '✅ Bestelling geslaagd!',
      description: 'Je bestelling is succesvol geplaatst.',
    },
  },
  error_messages: {
    failed_to_load: 'Bestelling kon niet worden geladen. Probeer het opnieuw.',
    payment_failed: 'Betaling mislukt, probeer het opnieuw',
  },
  load_failed: {
    title: 'We konden je bestelling niet laden',
    description:
      'Er is iets misgegaan bij het laden van je bestelgegevens. Probeer het opnieuw. Als het blijft gebeuren, neem dan contact op met de support en we helpen je direct.',
  },
};
